import type { TOC } from '@ember/component/template-only'
import LoadingSpinner from 'district-ui-client/components/loading-spinner'
import RouteTemplate from 'ember-route-template'

export const LoadingRouteTemplate: TOC<unknown> = <template><LoadingSpinner /></template>

export default RouteTemplate(LoadingRouteTemplate)
